import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ArchivoAdjunto`

export function subirArchivo(archivo) {
  return http.post(`${API_ENDPOINT}/Upload`, archivo)
}

export function buscarAdjuntos(idUsuario, idTipo) {
  return http.get(`${API_ENDPOINT}/BuscarAdjuntos/${idUsuario}/${idTipo}`)
}

export function buscarUltimoAdjunto(idUsuario, idTipo, idDoc = 0) {
  return http.get(`${API_ENDPOINT}/BuscarUltimoAdjunto/${idUsuario}/${idTipo}/${idDoc}`)
}

export function buscarArchivo(idUsuario, idTipo, idPresupuesto) {
  return http.get(
    `${API_ENDPOINT}/BuscarArchivo/${idUsuario}/${idTipo}/${
      idPresupuesto ? idPresupuesto : 0
    }`
  )
}

export function modificarOrdenImagenes(listaAdjuntos) {
  return http.post(`${API_ENDPOINT}/ModificarOrdenImagenes`, listaAdjuntos, {
    meta: {
      toastMessage: 'Ocurrió un error al modificar el orden de las imágenes.',
      tipoError: 'adjunto'
    }
  })
}

export function buscarAdjuntosPorId(idAdjunto) {
  return http.get(`${API_ENDPOINT}/BuscarAdjuntosMensaje/${idAdjunto}`)
}
